import { OrderType, useOrderQuery } from "@pathwright/graphql-client/src/generated"
import CurriculumLicenseOrderConfirmationCard, {
  CurriculumLicenseOrderConfirmation
} from "./CurriculumLicenseOrderConfirmationCard"
import GroupLicenseOrderConfirmationCard, {
  GroupLicenseOrderConfirmation
} from "./GroupLicenseOrderConfirmationCard"
import GroupSubscriptionOrderConfirmationCard, {
  GroupSubscriptionOrderConfirmation
} from "./GroupSubscriptionOrderConfirmationCard"
import { OrderProcessingLoading } from "./OrderProcessing"
import RegistrationOrderConfirmationCard, {
  RegistrationOrderConfirmation
} from "./RegistrationOrderConfirmationCard"
import SubscriptionConfirmationCard, {
  SubscriptionConfirmation
} from "./SubscriptionOrderConfirmationCard"
import { OnOrderFulfilledCallback } from "./useOrderPollingQuery"

export type RenderActionButton = (props: {
  children: string
  to: string
}) => React.ReactNode | { children: string; to: string }

type OrderConfirmationContainerProps = {
  orderId: number
  onOrderFulfilled?: OnOrderFulfilledCallback
  renderActionButton?: RenderActionButton
  card?: any
}

function OrderConfirmationContainer(props: OrderConfirmationContainerProps) {
  const { orderId } = props
  const orderQuery = useOrderQuery({
    variables: {
      id: orderId
    }
  })
  const order = orderQuery.data?.order
  const orderType = order?.order_type

  function getOrderConfirmationComponent() {
    switch (orderType) {
      case OrderType.SchoolSubscription:
        return props.card
          ? SubscriptionConfirmationCard
          : SubscriptionConfirmation
      case OrderType.GroupSubscription:
        return props.card
          ? GroupSubscriptionOrderConfirmationCard
          : GroupSubscriptionOrderConfirmation
      case OrderType.Registration:
        return props.card
          ? RegistrationOrderConfirmationCard
          : RegistrationOrderConfirmation
      case OrderType.GroupLicense:
        return props.card
          ? GroupLicenseOrderConfirmationCard
          : GroupLicenseOrderConfirmation
      case OrderType.CurriculumLicense:
        return props.card
          ? CurriculumLicenseOrderConfirmationCard
          : CurriculumLicenseOrderConfirmation
      default:
        return null
    }
  }

  const OrderConfirmationComponent = getOrderConfirmationComponent()
  return OrderConfirmationComponent ? (
    <OrderConfirmationComponent {...props} card={props.card} />
  ) : (
    <OrderProcessingLoading />
  )
}

export default OrderConfirmationContainer
